import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'bidi-content-views',
  templateUrl: './content-views.component.html',
  styleUrls: ['./content-views.component.scss']
})
export class ContentViewsComponent implements OnInit {
  @Input() views;
  text = 'visitas';
  constructor( ) {}

  ngOnInit () {
    if (this.views === 1) {
      this.text = 'visita';
    }
  }
}
